import React from "react";
import { Bullet, CloseCircle } from "../../Theme/Icons";
import { PopupBody, PopupWrapper } from "./CommonPopup";
import { Button, Flexbox, InputField } from "../../Theme/GlobalStyles";
import { Text } from "../../Theme/Typography";
import { globalTheme } from "../../Theme/Theme";


const MODE_PRESETS = {
  cancel: {
    title: "Cancel Booking?",
    description: ({ roomName }) => `Are you sure you want to cancel booking for ${roomName} ?`,
    cancelText: "No",
    confirmText: "Yes, Cancel",
  },
  accept: {
    title: "Accept Booking?",
    description: ({ roomName }) => `Are you sure you want to accept booking for ${roomName} ?`,
    cancelText: "Cancel",
    confirmText: "Yes, Accept",
  },
  override: {
    title: "Override Booking?",
    description: () =>
      "This slot is already booked. Overriding will replace the existing booking. Do you want to continue?",
    cancelText: "Cancel",
    confirmText: "Yes, Override",
  },
  reject : {
    title : "Reject Booking",
    description : ({roomName}) => `Are you sure you want to reject the booking for ${roomName}?`,
    cancelText : "No, Keep it",
    confirmText : "Yes, Reject"
  }
};

export const CancelBookingBody = ({
  onCancel,
  onConfirm,
  mode = "cancel",
  title,
  description,
  cancelText,
  confirmText,
  roomName = "NPS",
  bookingDate = "Thu, 12 Sep, 2026",
  bookingTime = "10:00 AM -12:00 PM",
  duration = "2 hrs",
  bookedBy = "John Doe",
  isPopupFetching,
  reason,
  setReason,

}) => {
  const preset = MODE_PRESETS[mode] || MODE_PRESETS.cancel;
  const resolvedTitle = title || preset.title;
  const resolvedDescription =
    description || preset.description({ roomName, bookingDate, bookingTime, bookedBy });
  const resolvedCancel = cancelText || preset.cancelText;
  const resolvedConfirm = confirmText || preset.confirmText;

  return (
    <>
      <Flexbox spaceBW alignCenter>
        <Text font18 inter semiBold white>
          {resolvedTitle}
        </Text>
        <CloseCircle className={"pointer"} onClick={() => onCancel(false)} />
      </Flexbox>

      <Flexbox
        style={{
          height: 1,
          background: globalTheme.colors.white1,
          opacity: 0.18,
          margin: "16px 0",
        }}
      />

      <Text font14 inter medium white className="mb16">
        {resolvedDescription}
      </Text>

      <Flexbox wrap
        gap={6}
        padding={"14px 16px"}
        className="mt12 mb20"
        background={globalTheme.colors.white1}
        borderRadius={12}
      >
        <Flexbox alignCenter wrap gap={2} maxWidth='max-content'>
          <Text font13 inter semiBold black3>Existing booking:</Text>
          <Text font13 inter regular black3>{roomName}</Text>
        </Flexbox>
        <Flexbox alignCenter gap={6} maxWidth='max-content'>
          <Bullet />
          <Text font13 inter regular black3>{bookingDate}</Text>
        </Flexbox>
        <Flexbox alignCenter gap={6} maxWidth='max-content'>
          <Bullet/>
          <Text font13 inter regular black3>{bookingTime} ({duration})</Text>
        </Flexbox>
        <Flexbox alignCenter gap={6} maxWidth='max-content'>
          <Bullet />
          <Text font13 inter regular black3>By {bookedBy}</Text>
        </Flexbox>
      </Flexbox>

      {/* The reason box only makes sense for cancel/reject, and only when the
          caller actually owns a reason state to write into. */}
      {typeof setReason === "function" && (mode === "cancel" || mode === "reject") && (
        <Flexbox alignCenter gap={12} justiCenter>
          <InputField
            label={mode === "reject" ? "Reason for rejection" : "Reason for cancellation"}
            placeholder="Enter reason (optional)"
            onChange={(e) => setReason(e.target.value)}
            value={reason ?? ""}
          />
        </Flexbox>
      )}

      <Flexbox alignCenter gap={12} justiCenter>
        <Button
          buttonMd
          whiteFilled
          name={resolvedCancel}
          onClick={() => onCancel(false)}
        />
        <Button
          buttonMd
          redFilled
          name={resolvedConfirm}
          isWaiting={isPopupFetching}
          onClick={() => onConfirm?.()}
        />
      </Flexbox>
    </>
  );
};

const CancelBookingPopup = ({ showActive, ...rest }) => (
  <PopupWrapper className={`${showActive ? "active" : ""}`}>
    <PopupBody maxWidth={520} padding={24}>
      <CancelBookingBody {...rest} />
    </PopupBody>
  </PopupWrapper>
);

export default CancelBookingPopup;
